<div class="analise-shell">
  <header class="cabecalho-analise">
    <div class="cabecalho-identidade">
      <div class="cabecalho-icone" aria-hidden="true">
        <i class="fas fa-map-marked-alt"></i>
      </div>
      <div>
        <span class="cabecalho-sobretitulo">Operação logística</span>
        <h1>Mapa de entregas</h1>
        <p>Acompanhe a cobertura, os prazos e o ritmo da sua operação em um só lugar.</p>
      </div>
    </div>

    <button type="button"
            class="status-atualizacao"
            [ngClass]="{'carregando': carregandoDesempenho}"
            [disabled]="carregandoDesempenho"
            (click)="carregueRelatorio()">
      <span class="status-pulso"></span>
      <span>{{carregandoDesempenho ? 'Atualizando dados' : 'Atualizar agora'}}</span>
      <i class="fe-refresh-cw" aria-hidden="true"></i>
    </button>
  </header>

  <section class="painel-filtros" aria-label="Filtros da análise">
    <div class="filtros-cabecalho">
      <div class="filtros-titulo">
        <span class="filtros-icone"><i class="fe-sliders"></i></span>
        <div>
          <h2>Visão da operação</h2>
          <p>Os resultados são atualizados ao alterar os filtros.</p>
        </div>
      </div>

      <div class="seletor-periodo" role="group" aria-label="Tipo de período">
        <button type="button"
                [ngClass]="{'ativo': periodoEspecifico}"
                [attr.aria-pressed]="periodoEspecifico"
                (click)="exibirPeriodoEspecifico()">
          Período
        </button>
        <button type="button"
                [ngClass]="{'ativo': !periodoEspecifico}"
                [attr.aria-pressed]="!periodoEspecifico"
                (click)="exibirPeriodoMensal()">
          Mês
        </button>
      </div>
    </div>

    <div class="filtros-conteudo">
      <div class="campo-filtro campo-mes" *ngIf="!periodoEspecifico">
        <label for="mes-analise">Mês analisado</label>
        <kendo-datepicker id="mes-analise"
                          class="form-control"
                          [bottomView]="'year'"
                          [topView]="'year'"
                          [format]="'MMMM yyyy'"
                          [activeView]="'year'"
                          [max]="hoje"
                          (valueChange)="mudouValorMes($event)"
                          [(value)]="valorMes">
        </kendo-datepicker>
      </div>

      <kendo-daterange class="campos-periodo" *ngIf="periodoEspecifico">
        <div class="campo-filtro">
          <label for="inicio-analise">Data inicial</label>
          <kendo-datetimepicker id="inicio-analise"
                               [ngModel]="filtro.inicio"
                               [max]="hoje"
                               (ngModelChange)="mudouInicio($event)">
            <kendo-datetimepicker-messages
              today="Hoje"
              toggle="Alterar data"
              cancel="Cancelar"
              dateTab="Data"
              timeTab="Hora"
              now="Agora"
              accept="Ok">
            </kendo-datetimepicker-messages>
          </kendo-datetimepicker>
        </div>

        <span class="separador-periodo" aria-hidden="true"><i class="fe-arrow-right"></i></span>

        <div class="campo-filtro">
          <label for="fim-analise">Data final</label>
          <kendo-datetimepicker id="fim-analise"
                               [ngModel]="filtro.fim"
                               [min]="filtro.inicio"
                               [max]="maxFim"
                               (ngModelChange)="mudouFim($event)">
            <kendo-datetimepicker-messages
              today="Hoje"
              toggle="Alterar data"
              cancel="Cancelar"
              dateTab="Data"
              timeTab="Hora"
              now="Agora"
              accept="Ok">
            </kendo-datetimepicker-messages>
          </kendo-datetimepicker>
        </div>
      </kendo-daterange>

      <div class="campo-filtro campo-entregador" *ngIf="entregadores.length > 1">
        <label for="entregador-analise">Entregador</label>
        <kendo-dropdownlist id="entregador-analise"
                            [filterable]="true"
                            name="entregador"
                            [ngModel]="filtro.entregador"
                            (ngModelChange)="mudouEntregador($event)"
                            (filterChange)="busqueEntregadores($event)"
                            [data]="entregadores"
                            textField="nome"
                            class="form-control">
        </kendo-dropdownlist>
      </div>

      <div class="filtro-limite" *ngIf="periodoEspecifico">
        <i class="fe-calendar"></i>
        <span>Máximo de 31 dias</span>
      </div>
    </div>

    <div class="aviso-periodo" *ngIf="avisoPeriodo">
      <i class="fe-info"></i>
      <span>{{avisoPeriodo}}</span>
    </div>
  </section>

  <main class="analise-pedidos">
    <div class="estado-carregamento" *ngIf="carregandoDesempenho && !desempenhoEntregas">
      <span class="carregamento-icone"><i class="k-icon k-i-loading"></i></span>
      <strong>Preparando o mapa</strong>
      <span>Organizando entregas, prazos e regiões do período.</span>
    </div>

    <div class="estado-erro" *ngIf="erroDesempenho && !carregandoDesempenho">
      <span class="estado-erro-icone"><i class="fe-alert-triangle"></i></span>
      <div>
        <strong>Não foi possível carregar a análise</strong>
        <span>{{erroDesempenho}}</span>
      </div>
    </div>

    <ng-container *ngIf="desempenhoEntregas">
      <section class="grade-indicadores" aria-label="Resumo da operação">
        <article class="indicador-pedido indicador-destaque">
          <span class="indicador-icone"><i class="fe-shopping-bag"></i></span>
          <div>
            <span class="indicador-label">Pedidos</span>
            <strong>{{desempenhoEntregas.indicadores?.quantidadeEntregas || 0}}</strong>
          </div>
          <small>Total no período</small>
        </article>

        <article class="indicador-pedido">
          <span class="indicador-icone indicador-icone-azul"><i class="fe-map-pin"></i></span>
          <div>
            <span class="indicador-label">No mapa</span>
            <strong>{{desempenhoEntregas.indicadores?.entregasNoMapa || 0}}</strong>
          </div>
          <small>Com posição visível</small>
        </article>

        <article class="indicador-pedido">
          <span class="indicador-icone indicador-icone-neutro"><i class="fe-map"></i></span>
          <div>
            <span class="indicador-label">Sem localização</span>
            <strong>{{desempenhoEntregas.indicadores?.entregasSemLocalizacao || 0}}</strong>
          </div>
          <small>Presentes nos resumos</small>
        </article>

        <article class="indicador-pedido">
          <span class="indicador-icone indicador-icone-azul"><i class="fe-clock"></i></span>
          <div>
            <span class="indicador-label">Duração média</span>
            <strong>{{formateMinutos(desempenhoEntregas.indicadores?.duracaoMediaMinutos)}}</strong>
          </div>
          <small>Do aceite à entrega</small>
        </article>

        <article class="indicador-pedido indicador-sucesso">
          <span class="indicador-icone"><i class="fe-check-circle"></i></span>
          <div>
            <span class="indicador-label">No prazo</span>
            <strong>{{formatePercentual(desempenhoEntregas.indicadores?.percentualNoPrazo)}}</strong>
          </div>
          <small>Índice de pontualidade</small>
        </article>

        <article class="indicador-pedido indicador-atencao">
          <span class="indicador-icone"><i class="fe-alert-circle"></i></span>
          <div>
            <span class="indicador-label">Atrasados</span>
            <strong>{{desempenhoEntregas.indicadores?.entregasAtrasadas || 0}}</strong>
          </div>
          <small>Pedidos fora do prazo</small>
        </article>
      </section>

      <div class="avisos-operacao" *ngIf="usaMapaAproximado() || desempenhoEntregas.localizacao?.semLocalizacao > 0">
        <div class="aviso-localizacao aviso-localizacao-estimada" *ngIf="usaMapaAproximado()">
          <span class="aviso-icone"><i class="fe-info"></i></span>
          <div>
            <strong>O mapa contém posições aproximadas</strong>
            <span>Pedidos sem coordenadas foram posicionados pelo endereço ou pelo bairro.</span>
          </div>
        </div>

        <div class="aviso-localizacao" *ngIf="desempenhoEntregas.localizacao?.semLocalizacao > 0">
          <span class="aviso-icone"><i class="fe-alert-triangle"></i></span>
          <div>
            <strong>{{desempenhoEntregas.localizacao.semLocalizacao}} pedido(s) sem localização suficiente</strong>
            <span>Eles continuam contabilizados nos resumos por bairro, origem e últimos pedidos.</span>
          </div>
        </div>
      </div>

      <div class="workspace-mapa">
        <section class="painel-mapa-pedidos" [ngClass]="{'painel-mapa-compacto': !obtenhaTemPontosMapa()}">
          <div class="painel-mapa-cabecalho">
            <div class="painel-mapa-info">
              <span class="secao-sobretitulo">Distribuição geográfica</span>
              <h2>Mapa das entregas</h2>
              <p>
                <strong>{{desempenhoEntregas.localizacao?.registrada || 0}}</strong> registradas
                <span class="separador-texto">•</span>
                <strong>{{obtenhaTotalLocalizacaoAproximada()}}</strong> aproximadas
              </p>
              <span class="mapa-limite" *ngIf="desempenhoEntregas.mapa?.resultadoLimitado">
                <i class="fe-info" aria-hidden="true"></i>
                Exibindo {{desempenhoEntregas.mapa.entregas.length}} de {{desempenhoEntregas.mapa.totalEntregas}} pontos
              </span>
            </div>

            <button type="button"
                    class="acao-agrupar-entregas"
                    [ngClass]="{'ativo': agruparEntregasProximas}"
                    *ngIf="obtenhaEntregasMapa().length > 1"
                    [attr.aria-pressed]="agruparEntregasProximas"
                    [title]="agruparEntregasProximas ? 'Mostrar entregas individualmente' : 'Agrupar entregas próximas'"
                    (click)="alterneAgrupamentoEntregasProximas()">
              <i class="fe-layers"></i>
              <span>{{agruparEntregasProximas ? 'Entregas agrupadas' : 'Agrupar próximas'}}</span>
            </button>
          </div>

          <div class="mapa-pedidos" *ngIf="obtenhaTemPontosMapa()">
            <div id="mapa-analise-pedidos" class="mapa-google-pedidos"></div>
            <div class="mapa-vazio" *ngIf="erroMapaAnaliseEntregas">
              <span class="mapa-vazio-icone"><i class="fe-map"></i></span>
              <strong>Mapa indisponível</strong>
              <span>{{erroMapaAnaliseEntregas}}</span>
            </div>
          </div>

          <div class="mapa-compacto" *ngIf="!obtenhaTemPontosMapa()">
            <div class="mapa-compacto-visual" aria-hidden="true">
              <span class="mapa-compacto-orbita mapa-compacto-orbita-maior"></span>
              <span class="mapa-compacto-orbita"></span>
              <span class="mapa-compacto-icone"><i class="fe-map-pin"></i></span>
            </div>

            <div class="mapa-compacto-conteudo">
              <span class="secao-sobretitulo">Aguardando coordenadas</span>
              <strong>Há pedidos no período, mas nenhum possui posição no mapa.</strong>
              <p>O endereço continua salvo no pedido. Para criar o marcador, a entrega também precisa ter latitude e longitude.</p>

              <div class="mapa-compacto-metricas" aria-label="Resumo de localização">
                <span>
                  <strong>{{desempenhoEntregas.indicadores?.quantidadeEntregas || 0}}</strong>
                  pedidos no período
                </span>
                <span>
                  <strong>{{desempenhoEntregas.indicadores?.entregasSemLocalizacao || 0}}</strong>
                  sem coordenadas
                </span>
              </div>
            </div>

            <a class="mapa-compacto-acao" href="#ultimos-pedidos">
              <span>Revisar pedidos</span>
              <i class="fe-arrow-down" aria-hidden="true"></i>
            </a>
          </div>

          <div class="legenda-mapa" *ngIf="obtenhaTemPontosMapa()">
            <span><i class="legenda registrada"></i> Registrada</span>
            <span><i class="legenda aproximada"></i> Endereço aproximado</span>
            <span><i class="legenda bairro"></i> Bairro aproximado</span>
            <span><i class="legenda fora-area"></i> Fora da área</span>
          </div>
        </section>

        <aside class="painel-ritmo" aria-label="Tempos da operação">
          <div class="ritmo-cabecalho">
            <span class="secao-sobretitulo">Tempos médios</span>
            <h2>Ritmo da operação</h2>
            <p>Tempo médio entre cada mudança de status.</p>

            <div class="ritmo-regra">
              <i class="fe-info" aria-hidden="true"></i>
              <span>Consideramos apenas os pedidos que concluíram as duas etapas do intervalo.</span>
            </div>
          </div>

          <div class="lista-tempos">
            <div class="tempo-item">
              <span class="tempo-icone"><i class="fe-check-square"></i></span>
              <div class="tempo-descricao">
                <span>Confirmação</span>
                <small>Pedido criado <i class="fe-arrow-right"></i> 1ª movimentação</small>
                <em [ngClass]="{'sem-amostra': !desempenhoEntregas.metricasTempo?.amostras?.confirmacao}">
                  {{formateAmostraTempo(desempenhoEntregas.metricasTempo?.amostras?.confirmacao)}}
                </em>
              </div>
              <strong [ngClass]="{'tempo-sem-dados': desempenhoEntregas.metricasTempo?.tempoConfirmacaoMinutos == null}">
                {{formateMinutos(desempenhoEntregas.metricasTempo?.tempoConfirmacaoMinutos)}}
              </strong>
            </div>
            <div class="tempo-item">
              <span class="tempo-icone"><i class="fe-box"></i></span>
              <div class="tempo-descricao">
                <span>Preparo</span>
                <small>1ª movimentação <i class="fe-arrow-right"></i> Pronto</small>
                <em [ngClass]="{'sem-amostra': !desempenhoEntregas.metricasTempo?.amostras?.preparo}">
                  {{formateAmostraTempo(desempenhoEntregas.metricasTempo?.amostras?.preparo)}}
                </em>
              </div>
              <strong [ngClass]="{'tempo-sem-dados': desempenhoEntregas.metricasTempo?.tempoPreparoMinutos == null}">
                {{formateMinutos(desempenhoEntregas.metricasTempo?.tempoPreparoMinutos)}}
              </strong>
            </div>
            <div class="tempo-item">
              <span class="tempo-icone"><i class="fe-pause-circle"></i></span>
              <div class="tempo-descricao">
                <span>Espera</span>
                <small>Pronto <i class="fe-arrow-right"></i> Em entrega</small>
                <em [ngClass]="{'sem-amostra': !desempenhoEntregas.metricasTempo?.amostras?.espera}">
                  {{formateAmostraTempo(desempenhoEntregas.metricasTempo?.amostras?.espera)}}
                </em>
              </div>
              <strong [ngClass]="{'tempo-sem-dados': desempenhoEntregas.metricasTempo?.tempoEsperaMinutos == null}">
                {{formateMinutos(desempenhoEntregas.metricasTempo?.tempoEsperaMinutos)}}
              </strong>
            </div>
            <div class="tempo-item">
              <span class="tempo-icone"><i class="fe-navigation"></i></span>
              <div class="tempo-descricao">
                <span>Entrega</span>
                <small>Em entrega <i class="fe-arrow-right"></i> Entregue</small>
                <em [ngClass]="{'sem-amostra': !desempenhoEntregas.metricasTempo?.amostras?.entrega}">
                  {{formateAmostraTempo(desempenhoEntregas.metricasTempo?.amostras?.entrega)}}
                </em>
              </div>
              <strong [ngClass]="{'tempo-sem-dados': desempenhoEntregas.metricasTempo?.tempoEntregaMinutos == null}">
                {{formateMinutos(desempenhoEntregas.metricasTempo?.tempoEntregaMinutos)}}
              </strong>
            </div>
          </div>

          <div class="ritmo-observacao">
            <i class="fe-zap" aria-hidden="true"></i>
            <span>Se uma etapa for pulada, usamos o próximo status registrado como referência.</span>
          </div>

          <div class="prazo-resumo">
            <div class="prazo-titulo">
              <span>Pontualidade <small>Entregas concluídas dentro do prazo previsto</small></span>
              <strong>{{formatePercentual(desempenhoEntregas.indicadores?.percentualNoPrazo)}}</strong>
            </div>
            <div class="progresso-prazo" aria-hidden="true">
              <span [style.width.%]="desempenhoEntregas.indicadores?.percentualNoPrazo || 0"></span>
            </div>
            <div class="prazo-detalhes">
              <div>
                <span>Atraso médio</span>
                <strong>{{formateMinutos(desempenhoEntregas.prazos?.atrasoMedioMinutos)}}</strong>
              </div>
              <div>
                <span>Maior atraso</span>
                <strong>{{formateMinutos(desempenhoEntregas.prazos?.maiorAtrasoMinutos)}}</strong>
              </div>
            </div>
          </div>
        </aside>
      </div>

      <section class="detalhes-operacao">
        <div class="detalhes-cabecalho">
          <div>
            <span class="secao-sobretitulo">Leitura detalhada</span>
            <h2>Detalhes da operação</h2>
          </div>
          <p>Compare as origens, os bairros e os pedidos mais recentes.</p>
        </div>

        <div class="grade-tabelas">
          <article class="tabela-analise">
            <div class="tabela-cabecalho">
              <span class="tabela-icone"><i class="fe-git-branch"></i></span>
              <div>
                <h3>Origem dos pedidos</h3>
                <p>Qual canal concentra mais entregas.</p>
              </div>
            </div>
            <div class="tabela-scroll">
              <table class="table table-sm mb-0">
                <thead>
                <tr>
                  <th>Origem</th>
                  <th class="text-right">Pedidos</th>
                  <th class="text-right">Localizados</th>
                  <th class="text-right">Sem local.</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let origem of desempenhoEntregas.resumoPorOrigem">
                  <td><strong>{{origem.origem}}</strong></td>
                  <td class="text-right numero-tabela">{{origem.pedidos}}</td>
                  <td class="text-right numero-tabela numero-sucesso">{{origem.comLocalizacao}}</td>
                  <td class="text-right numero-tabela">{{origem.semLocalizacao}}</td>
                </tr>
                <tr *ngIf="!desempenhoEntregas.resumoPorOrigem || desempenhoEntregas.resumoPorOrigem.length === 0">
                  <td colspan="4" class="estado-tabela-vazia">Nenhum pedido no período</td>
                </tr>
                </tbody>
              </table>
            </div>
          </article>

          <article class="tabela-analise">
            <div class="tabela-cabecalho">
              <span class="tabela-icone tabela-icone-verde"><i class="fe-home"></i></span>
              <div>
                <h3>Resumo por bairro</h3>
                <p>Volume e pontualidade por região.</p>
              </div>
            </div>
            <div class="tabela-scroll">
              <table class="table table-sm mb-0">
                <thead>
                <tr>
                  <th>Bairro</th>
                  <th class="text-right">Pedidos</th>
                  <th class="text-right">Sem local.</th>
                  <th class="text-right">No prazo</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let bairro of desempenhoEntregas.resumoPorBairro">
                  <td><strong>{{bairro.bairro}}</strong></td>
                  <td class="text-right numero-tabela">{{bairro.entregas}}</td>
                  <td class="text-right numero-tabela">{{bairro.semLocalizacao}}</td>
                  <td class="text-right numero-tabela numero-sucesso">{{bairro.noPrazo}}</td>
                </tr>
                <tr *ngIf="!desempenhoEntregas.resumoPorBairro || desempenhoEntregas.resumoPorBairro.length === 0">
                  <td colspan="4" class="estado-tabela-vazia">Nenhum pedido no período</td>
                </tr>
                </tbody>
              </table>
            </div>
          </article>

          <article class="tabela-analise tabela-pedidos" id="ultimos-pedidos">
            <div class="tabela-cabecalho">
              <span class="tabela-icone tabela-icone-laranja"><i class="fe-truck"></i></span>
              <div>
                <h3>Últimos pedidos</h3>
                <p>Acesso rápido aos pedidos recentes.</p>
              </div>
            </div>
            <div class="tabela-scroll">
              <table class="table table-sm mb-0">
                <thead>
                <tr>
                  <th>Pedido</th>
                  <th>Cliente</th>
                  <th>Status</th>
                  <th>Localização</th>
                  <th class="text-right">Horário</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let pedido of obtenhaUltimasEntregas()">
                  <td>
                    <a class="link-pedido" *ngIf="pedido.guidPedido" routerLink="/admin/pedidos/detalhes/{{pedido.guidPedido}}">
                      #{{pedido.codigoPedido}} <i class="fe-arrow-up-right"></i>
                    </a>
                    <strong *ngIf="!pedido.guidPedido">#{{pedido.codigoPedido}}</strong>
                  </td>
                  <td>
                    <strong class="pedido-cliente">{{pedido.nomeCliente || 'Cliente não informado'}}</strong>
                    <small class="pedido-origem">{{pedido.origemPedido}}</small>
                  </td>
                  <td>
                    <span class="status-pedido" [ngClass]="obtenhaClasseStatusPedido(pedido.status)">
                      <i></i>{{obtenhaStatusPedido(pedido.status)}}
                    </span>
                  </td>
                  <td>
                    <span class="localizacao-pedido" [ngClass]="{'sem-localizacao': pedido.tipoLocalizacao === 'sem_localizacao'}">
                      <i [class]="pedido.tipoLocalizacao === 'sem_localizacao' ? 'fe-alert-circle' : 'fe-map-pin'"></i>
                      {{obtenhaDescricaoLocalizacao(pedido)}}
                    </span>
                  </td>
                  <td class="text-right horario-pedido">{{pedido.horario | date:'HH:mm'}}</td>
                </tr>
                <tr *ngIf="!desempenhoEntregas.pedidos || desempenhoEntregas.pedidos.length === 0">
                  <td colspan="5" class="estado-tabela-vazia">Nenhum pedido no período</td>
                </tr>
                </tbody>
              </table>
            </div>
          </article>
        </div>
      </section>
    </ng-container>
  </main>
</div>
